import React, { useState } from "react";

const DataTable = ({ data, secondTable = false }) => {
  const [activeModalItemId, setActiveModalItemId] = useState(null); // Track the active modal

  const formatDateToIST = (dateString) => {
    const date = new Date(dateString);
    const istDate = new Date(date.getTime() + 5.5 * 60 * 60 * 1000);
    const day = String(istDate.getUTCDate()).padStart(2, '0');
    const month = String(istDate.getUTCMonth() + 1).padStart(2, '0');
    const year = istDate.getFullYear();
    const hours = String(istDate.getUTCHours()).padStart(2, '0');
    const minutes = String(istDate.getUTCMinutes()).padStart(2, '0');
    const seconds = String(istDate.getUTCSeconds()).padStart(2, '0');
    
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  const handleModalTrigger = (id) => {
    console.log("id", id);
    
    setActiveModalItemId(activeModalItemId === id ? null : id); // Toggle modal visibility
  };

  return (
    <div className="col-lg-12">
      <div className="card mb-8">
        <div className="card-body">
          {secondTable && `File No. ${(
                          data?.[0]?.nameFirm
                            ?.split(" ")
                            .map((val) => (val[0] ? val[0].toUpperCase() : ""))
                            .join("") || "") + data?.[0]?.projectId || ""
                        }`}
          <div className="table-responsive table-wrapper">
            {
              !secondTable ?(
                <>
                  <table id="data-table" className="table table-bordered table-hover">
                    <thead>
                      <tr className="t-header">
                        <th>File No</th>
                        <th>Firm Name</th>
                        <th>Processes</th>
                        <th>Last Updated</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.length > 0 ? (
                        data.map((item, index) => (
                          <tr key={index}>
                            <td>
                              {(
                                item.nameFirm
                                  ?.split(" ")
                                  .map((val) => (val[0] ? val[0].toUpperCase() : ""))
                                  .join("") || "") + item.projectId || ""
                              }
                            </td>
                            <td>{item.nameFirm}</td>
                            <td>
                              <button className="btn btn-primary" onClick={() => handleModalTrigger(item.projectId)}>
                                View Processes
                              </button>
                            </td>
                            <td>{formatDateToIST(item.last_updated)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </>
              ):
              (
                <>
                    <table id="data-table" className="table table-bordered table-hover">
                    <thead>
                      <tr className="t-header">
                        <th>Process</th>
                        <th>Last Updated</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        data?.[0]?.processes?.length > 0 &&
                        data?.[0]?.processes?.map((item) => {
                          return (
                            <tr>
                              <td>
                                {item?.process}
                              </td>
                              <td>
                                {formatDateToIST(item?.created_at)}
                              </td>
                            </tr>
                          );
                        })
                      }
                    </tbody>
                    </table>
                </>
              )
            }

            {/* Modal logic */}
            {activeModalItemId && (
              <div className="modal show d-block" tabIndex="-1">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Process Details</h5>
                      <button type="button" className="btn-close" onClick={() => handleModalTrigger(null)}></button>
                    </div>
                    <div className="modal-body">
                      {data?.find(item => item.projectId == activeModalItemId)?.processes?.map((process, index) => (
                        <p key={index}>{process.process || "Not Found"} - {formatDateToIST(process.created_at)}</p>
                      ))}
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={() => handleModalTrigger(null)}>Close</button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataTable;
